import React, { useEffect, useState, useRef } from 'react';
import { extendMouseEventForSafari } from '../../utils/methods';
import './index.scss';

const CustomCursor = ({ }) => {
  const [ status, setStatus ] = useState(null);
  const cursor = useRef(null);
  useEffect(() => {
    document.body.addEventListener('mousemove', handleWatchMouse);
    return () => document.body.removeEventListener('mousemove', handleWatchMouse);
  }, []);

  function handleWatchMouse(e) {
    extendMouseEventForSafari();
    const x = e.clientX;
    const y = e.clientY;
    cursor.current.setAttribute('style', `left: ${x}px; top: ${y}px`);

    const isButton = e.path.find( _ => _.localName === 'a' || _.localName === 'button') !== undefined;
    const isCard = e.path.find( elem => elem.localName === 'a' && elem.classList.contains('card-cover') === true ) !== undefined;
    const isScroll = e.path.find( elem => elem.localName === 'div' && elem.classList.contains('scroll-diver') === true ) !== undefined;
    const isWait = e.path.find( elem => elem.localName === 'div' && elem.classList.contains('load-cover') === true ) !== undefined;

    if (isButton && isCard) {
      setStatus('-card');
    }
    else if (isScroll && isButton) {
      setStatus('-hover');
    }
    else if (isScroll) {
      setStatus('-scroll');
    }
    else if (isWait) {
      setStatus('-wait');
    }
    else if (isButton) {
      setStatus('-hover');
    }
    else {
      setStatus(null);
    }
  }

  return <div className={`custom-cursor ${status ? status : ''}`} ref={cursor}>
    <div className="hint">
      { status === '-card' ? 'MORE' : ''}
      { status === '-scroll' ? 'SCROLL' : ''}
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>;
}

export default CustomCursor;